var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditPortfolio.jinja');
require('./MemberProfileEditPortfolio.less');

var MemberProfileEditPortfolioItem = require('front/components/MemberProfileEdit/MemberProfileEditPortfolioItem');
var MemberProfileEditPortfolioItemRuntime = require('front/components/MemberProfileEdit/MemberProfileEditPortfolioItemRuntime.jinja');

require('jquery-ui/ui/widgets/sortable');

module.exports = Base.extend({

    template: template,

    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },


    events: {
        'click .MemberProfileEditPortfolio-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditPortfolio-buttons-button--save': 'saveEdit',
        'click .MemberProfileEditPortfolio-buttons-image': 'addItem',
        'click .MemberProfileEditPortfolio-buttons-video': 'addItem'
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onResize', 'updateScroll', 'saveApi', 'getFormData');

        window.app.vent.on('MemberProfileEditPortfolioItem-remove', this.updateScroll);

        if (!app.settings.isPhone) {
            this.portfolioJsp = this.$('.MemberProfileEditPortfolio-body-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');

            this.portfolioSortable = this.$('.MemberProfileEditPortfolio-body-form').sortable({
                handle: '.MemberProfileEditPortfolioItem-inputIcons-drag',
                scroll: true
            });

            this.scrollOnDrag = window.app.utils.scrollOnDrag({
                sortInstance: this.portfolioSortable,
                scrollInstance: this.portfolioJsp
            });
        }

        var self = this;
        this.itemInstances = [];

        this.$('.MemberProfileEditPortfolioItem-inputWrapper').each(function () {
            var itemInstance = new MemberProfileEditPortfolioItem({
                el: this
            });

            self.itemInstances.push(itemInstance);
        });

        $(window).on('resize', this.onResize);
        this.onResize();

        Base.prototype.initialize.call(this, options);
    },


    onResize: function () {
        this.updateScroll();
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

    },


    deactivate: function (params) {
        $(window).off('resize', this.onResize);

        this.scrollOnDrag && this.scrollOnDrag.destroy();

        _.invoke(this.itemInstances, 'deactivate');
        delete this.itemInstances;

        return Base.prototype.deactivate.call(this, params);
    },


    saveEdit: function () {
        var form = this.getFormData();

        var $button = this.$('.MemberProfileEditPortfolio-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                portfolio: form
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updatePortfolio', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t edit portfolio!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'portfolio');
    },


    updateScroll: function () {
        if (!app.settings.isPhone) {
            this.portfolioJsp.reinitialise();
        }
    },


    addItem: function (e) {
        var component = $(e.currentTarget).data('component');

        var $template = $(MemberProfileEditPortfolioItemRuntime.render({
            data: {
                component: component
            },
            ind: this.$('.MemberProfileEditPortfolioItem-inputWrapper').length + 1
        }));

        this.$('.MemberProfileEditPortfolio-body-form').append($template);

        var itemInstance = new MemberProfileEditPortfolioItem({
            el: $template[0]
        });

        this.itemInstances.push(itemInstance);

        if (!app.settings.isPhone) {
            this.portfolioSortable.sortable('refresh');

            this.updateScroll();
            this.portfolioJsp.scrollToElement($template);
        } else {
            this.$('.MemberProfileEditPortfolio-body').animate({'scrollTop': $template.offset().top}, 400);
        }
    },


    getFormData: function () {
        var data = [];
        var order = 0;

        this.$('.MemberProfileEditPortfolioItem-inputWrapper').each(function () {
            var item = {};
            var isEmpty = true;

            $(this)
                .find('input, textarea')
                .each(function () {
                    var name = $(this).attr('name');
                    var val;

                    if (name == 'cover') {
                        val = $(this).attr('data-file');
                        item[name] = val ? JSON.parse($(this).attr('data-file')) : null;
                    } else {
                        val = $(this).val();

                        if (name == 'id') {
                            if (val) {
                                item[name] = val - 0;
                            }
                        } else {
                            item[name] = val;
                        }
                    }

                    if (name == 'cover' && val) {
                        isEmpty = false;
                    }
                });

            if (!isEmpty) {
                item.order = order++;
                data.push(item);
            }
        });

        return data;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditPortfolio.js
// module id = 218
// module chunks = 0